/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/05/2025 17:13
 *
 */

import {
  ApplicationConfig,
  importProvidersFrom,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';
import localeFr from '@angular/common/locales/fr';
import { initializerFactory } from './config/app-init.config';
import { interceptors, providers } from './config/providers.config';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentInitializer(initializerFactory),
    provideRouter(appRoutes),
    importProvidersFrom(BrowserModule, ...commonsProvidersFrom),
    ...commonsProviders,
    ...providers,
    provideHttpClient(withInterceptorsFromDi(), withInterceptors(interceptors)),
  ],
};
